export default __webpack_public_path__ + "ecc2ce43723b122e8e0ba2d7c1ad345f.jpg";